jQuery(document).ready(function($) {
	
	$.fn.responsiveMenu = function( options ) {
        // Default options
        var settings = $.extend({
			breakpoint: 300
        }, options );

		var menu_content = $('.menu-content');
		var sticky_menu_content = $('#header-sticky-menu .menu-content');
		var layout_header = $('.main_header_wrapper');
		var mobile_sticky = $('.mobile-header-sticky-menu');
		var body = $('body');
		var menu_element = $('.menu li');
					
		$.each($('.menu li'), function (index, value) {
			if ($(this).children('ul').length > 0 || $(this).children('div').length > 0) {
				$(this).children('a').append($('<span class="arrow"></span>'));
			}
		});
		
		// add to-left class tu parent ul
		if( $('.menu li').hasClass('to-left') ){ $('.menu li.to-left').parent('ul').addClass("to-left-ul"); }
		  		
		  		
		// hamburger btn
		$('#nav-icon').on('click', function(e) {
		    e.preventDefault();
		    e.stopPropagation();
		
		    if ( menu_content.hasClass( "open" ) ) {
				menu_content.removeClass('open');
				menu_content.addClass('close');
                layout_header.removeClass('fix_position');
				mobile_sticky.removeClass('fix_position');
                body.removeClass('overflow_hidden');
			}else{
				menu_content.addClass('open');
				menu_content.removeClass('close')
                layout_header.addClass('fix_position');
				mobile_sticky.addClass('fix_position');
                body.addClass('overflow_hidden');

			}
		
		    $(document).one('click', function closeMenu (e){
			    
			    var $browserWidth = window.innerWidth || document.documentElement.clientWidth;
			    if ($browserWidth < settings.breakpoint ) {
		        if(menu_content.has(e.target).length === 0){
		            menu_content.removeClass('open');
		            menu_content.addClass('close');
		            $('#nav-icon').removeClass('is-active');
					$('#sticky-nav-icon').removeClass('is-active');
                    layout_header.removeClass('fix_position');
					mobile_sticky.removeClass('fix_position');
                    body.addClass('overflow_hidden');
		        } else {
		            $(document).one('click', closeMenu);
		        }
		        }
		    });
		});

		// hamburger sticky btn
		$('#sticky-nav-icon').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			if ( sticky_menu_content.hasClass( "open" ) ) {
				sticky_menu_content.removeClass('open');
				sticky_menu_content.addClass('close');
				layout_header.removeClass('fix_position');
				mobile_sticky.removeClass('fix_position');
				body.removeClass('overflow_hidden');
			}else{
				sticky_menu_content.addClass('open');
				sticky_menu_content.removeClass('close')
				sticky_menu_content.addClass('fix_position');
				mobile_sticky.addClass('fix_position');
				body.addClass('overflow_hidden');
			}

			$(document).one('click', function closeMenu (e){

				var $browserWidth = window.innerWidth || document.documentElement.clientWidth;
				if ($browserWidth < settings.breakpoint ) {
					if(menu_content.has(e.target).length === 0){
						menu_content.removeClass('open');
						menu_content.addClass('close');
						sticky_menu_content.removeClass('open');
						sticky_menu_content.addClass('close');
						$('#nav-icon').removeClass('is-active');
						$('#sticky-nav-icon').removeClass('is-active');
						layout_header.removeClass('fix_position');
						mobile_sticky.removeClass('fix_position');
						//body.addClass('overflow_hidden');
					} else {
						$(document).one('click', closeMenu);
					}
				}
			});
		});
	
		// init responsive
		menuStuff();
	
		$(window).resize(function () {
			menuStuff();
		});
		
		$('#nav-icon').click(function(e){
			e.preventDefault();
			$(this).toggleClass('is-active');
		});

		$('#sticky-nav-icon').click(function(e){
			e.preventDefault();
			$(this).toggleClass('is-active');
		});
	
	
		function menuStuff() {
		
			var $browserWidth = window.innerWidth || document.documentElement.clientWidth;
	
			var menu_content = $('.menu-content');
			var menu_element = $('.menu li');
			var arrow = $('.menu__item span.arrow');
			var submenu_element = $('.menu__sub-menu');
	
			var hamburger = $('#nav-icon');
			var hamburger_sticky = $('#sticky-nav-icon');
	
			// desktop size
			if ( $browserWidth > settings.breakpoint ) {
				
				$('.menu .menu__item .menu__link').removeClass('active-parent');
				
				menu_content.removeClass('open').removeClass('close');
				arrow.removeClass('open');
				hamburger.removeClass('is-active');
				hamburger_sticky.removeClass('is-active');
				
				submenu_element.removeClass('open');
				submenu_element.removeClass('open').hide();

				//unbind arrow hover event
				arrow.unbind();
				
				menu_element.unbind().hover(function (e) {
					e.preventDefault();
	
					if( $(this).children('ul').hasClass( "menu__sub-menu" ) || $(this).children('div').hasClass( "menu__sub-menu" ) ){ 
						var element = $(this);
						var level = '.menu__sub-menu';
						xlScreen(element, level); 
					}
				});
	
			// mobile size
			} else {
				
				//unbind li click event
				menu_element.unbind();
	   
				arrow.unbind().click(function (e) {
	       
					e.preventDefault();
	
					if( $(this).closest('li').children('ul').hasClass( "menu__sub-menu" ) ){ 
						var level = '.menu__sub-menu'; 
						var element = $(this);
						xsScreen(element, level);
					
					}
				});
			}
	
			function xsScreen(element, level) {
				
				if( element.closest('li').children(level).hasClass('open') ){
				 	
	       		 	element.closest('li').children(level).slideUp(250).removeClass("open");
	       		 	element.parent('a').removeClass("active-parent");
	       		 	element.removeClass("open");
	       		 	
		  		}else{
	
			  		element.closest('li').children(level).slideDown(250).addClass('open');
			  		element.parent('a').addClass("active-parent");
			  		element.addClass("open");
		  		}
			}
	
			function xlScreen(element, level) {
		
				if( element.children(level).hasClass('open') ){
				 	
	       		 	element.children(level).removeClass("open");
	       		 	element.children('a').removeClass("active-parent");
	       		 	
		  		}else{
	
			  		element.children(level).show(1).addClass('open');
			  		element.children('a').addClass("active-parent");
		  		}
			}
		}
	};

});

$(document).ready(function($) {
    $('.menu').responsiveMenu({
        breakpoint: '1920'
    });

	var didScroll;
	var lastScrollTop = 0;

	$(window).scroll(function(event){
		didScroll = true;
	});

	setInterval(function(){
		if(didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 200);

	function hasScrolled() {
		if(window.currentPage == "product"){
			return;
		}

		var navbarHeight = $('.mobile_layout_wrapper').outerHeight();
		var st = $(this).scrollTop();

		//eger scroll sticky'den daha yukaridaysa menuyu goster
		if(st < navbarHeight)
		{
			$('.mobile_layout_wrapper').removeClass('site-header--fixed_on_mobile').removeClass('site-header--fixed_on_mobile_transition');
			$('.mobile-header-sticky-menu-fixed').removeClass('mobile-header-sticky-menu-fixed-show');
		}

		//eger scroll sticky menu'den daha asagidaysa ve yukari scroll yapilmissa sticky menu'yu fixed yaparak animasyonlu bir sekilde getir
		else if( st > navbarHeight && st < lastScrollTop )
		{
			$('.mobile_layout_wrapper')
				.addClass('site-header--fixed_on_mobile')
				.removeClass('site-header--fixed_on_mobile_transition');
			$('.mobile-header-sticky-menu-fixed').addClass('mobile-header-sticky-menu-fixed-show');
			//$('body').removeClass('menuStickyActiveOverflow');
		}
		//diger tum durumlarda menu'yu gizle gorunuyorsa animasyonu olarak kaybet
		else
		{
			$('.mobile_layout_wrapper').removeClass('site-header--fixed_on_mobile');
			$('.mobile-header-sticky-menu-fixed').removeClass('mobile-header-sticky-menu-fixed-show');

			if( st > navbarHeight ) {
				$('.site-header').addClass('site-header--fixed_on_mobile_transition');
			}
		}

		lastScrollTop = st;
	}


});



function searchToggle(obj, evt){
	var container = $(obj).closest('.search-wrapper');
	if(!container.hasClass('active')){
		container.addClass('active');
		evt.preventDefault();
		$('body').removeClass('overflow_hidden')
	}
	else if(container.hasClass('active') && $(obj).closest('.input-holder').length == 0){
		container.removeClass('active');
		// clear input
		container.find('.search-input').val('');
	}
}

